var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9861 19.3017L19.2505 8.05363C19.128 7.33439 18.4951 6.79493 17.76 6.79493H15.9632V5.85592C15.9632 3.7382 14.2073 2 12.0225 2C9.83776 2 8.08189 3.71818 8.08189 5.85592V6.79493H6.28507C5.52965 6.79493 4.89673 7.33439 4.7946 8.05363L3.01828 19.3017C2.87528 20.2007 3.58998 21 4.50875 21H19.4751C20.4142 21 21.1086 20.2009 20.9859 19.3017H20.9861ZM10.2258 5.87593C10.2258 4.91698 11.0221 4.13781 12.0022 4.13781C12.9822 4.13781 13.7785 4.91698 13.7785 5.87593V6.81494H10.2258V5.87593Z",
    fill: "#2a7f77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts1);
export default __webpack_public_path__ + "static/media/products1.1d0b54b0f06b0e5f2c68b3ca495382e5.svg";
export { ForwardRef as ReactComponent };